import React from "react";
// import sectionImage from '../../../assets/media/services/second section image.webp'
// import sectionImage from "../../../assets/media/services/Service_Section02.webp";
// import Center_Section_Primary from "../../global_components/Center Section/Center_Section_Primary";
// import Form_01 from "../../Forms/Form_01";
import Title_and_Text from "../../global_components/Title_and_Text/Title_and_Text";

const Section022 = () => {
  return (
    // <Center_Section_Primary
    //   src={sectionImage}
    //   alt={"Contact us"}
    //   title_purple={"Contact us"}
    //   text={
    //     "With our extensive experience in logistics, we have developed an efficient optimization to offer reliable and competitive shipping services for your cargo anywhere across the globe."
    //   }
    //   text_box_width={"99%"}
    //   form={<Form_01 class={"rahship-form"} serviceDropdown={true} />}
    // />
    <div class="container mb-5">
      <Title_and_Text
        title_purple={"Contact us"}
        text={
          "With our extensive experience in logistics, we have developed an efficient optimization to offer reliable and competitive shipping services for your cargo anywhere across the globe."
        }
        text_box_width={"70%"}
      />

      <div class="row my-5 ">
        <div class="col-sm-6 col-md-6 col-lg-3">
          <h3>
            <strong>DUBAI</strong>
          </h3>
          <p>RAH SHIPPING & LOGISTIC LLC</p>
          <p>901, API WORLD TOWER</p>
          <p>SHEIKH ZAYED ROAD</p>
          <p>DUBAI, UNITED ARAB EMIRATES</p>
          <p>Tel: +971-4-3204766</p>
          <p>Email: dxb@rahshiplog.com</p>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3">
          <h3>
            <strong>KARACHI</strong>
          </h3>
          <p>RAH SHIPPING & LOGISTICS (SMC) PVT LTD</p>
          <p>305, IBRAHIM TRADE TOWER</p>
          <p>SHAHRAH-E-FAISAL</p>
          <p>KARACHI, PAKISTAN</p>
          <p>Tel: +92-21-34538118</p>
          <p>Email: khi@rahshiplog.com</p>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3">
          <h3>
            <strong>JEBEL ALI</strong>
          </h3>
          <p>RAH SHIPPING & LOGISTIC LLC (BRANCH)</p>
          <p>FZS/AD05, JAFZA SOUTH</p>
          <p>JEBEL ALI FREEZONE</p>
          <p>JEBEL ALI, UNITED ARAB EMIRATES</p>
          <p>TEL: +971-50-1675488</p>
          <p>Email: jafza@rahshiplog.com</p>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-3">
          <h3>
            <strong>ROTTERDAM</strong>
          </h3>
          <p>RAH SHIPPING & LOGISTIC BV</p>
          <p>VERDIEPING 1, WILLEMSWERF</p>
          <p>BOOMPJEES 40, 3011 XB</p>
          <p>JEBEL ALI, UNITED ARAB EMIRATES</p>
          <p>TEL: +31-6-13823515</p>
          <p>Email: rtm@rahshiplog.com</p>
        </div>
      </div>
    </div>
  );
};

export default Section022;
